import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import FilterIcon from "@mui/icons-material/Tune";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Paper,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CircleLoader } from "react-spinners";
import {
  customerDeleteRequest,
  customerResetState,
  customerViewAllRequest,
} from "../../../redux/customer/CustomerAction";
import { getColumnWidth } from "../../../style/datagridMQ";
import { filterStyles, styles } from "../../components/LoginStyles";
import {
  ActiveValue,
  CapsuleValue,
  InactiveValue,
  StyledContainer,
} from "../../components/style";
import CustomDataGrid from "../../constant/commondatagrid";
import { generalCustomers } from "../../constant/data";
import Pagination from "../../constant/CommonPagenation";
import DeleteDialog from "../../constant/commonDeleteDialogBox";
import { WholesalerImageCell } from "../../constant/imageList";

const ActionMenu = ({ user, onDelete }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigator = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    navigator(`/admin/customer/edit/${user.id}`);
  };

  const handleDelete = () => {
    onDelete(user.id);
    handleClose();
  };

  const handleView = () => {
    navigator(`/admin/customer/view/${user.id}`);
    handleClose();
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreHorizIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={handleView} sx={styles.viewDetail}>
          View Detail
        </MenuItem>
        <MenuItem onClick={handleEdit} sx={styles.action}>
          Edit
        </MenuItem>
        <MenuItem onClick={handleDelete} sx={styles.action}>
          Delete
        </MenuItem>
      </Menu>
    </>
  );
};

const GeneralCustomers = () => {
  const [rows, setRows] = useState([]);
  const [selection, setSelection] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [openDialog, setOpenDialog] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [emptyList, setEmptyList] = useState([]);
  //search
  const [searchTerm, setSearchTerm] = useState("");

  const dispatch = useDispatch();

  const customerViewAllState = useSelector(
    (state) => state.customer?.viewAllCustomer || {}
  );
  const customerList = customerViewAllState?.data || [];
  const totalRecords = customerViewAllState?.totalRecords || 0;
  const customerPageSize = customerViewAllState?.pageSize || 10;

  const customerDeleteState = useSelector(
    (state) => state.customer?.deleteCustomer || {}
  );

  const columns = (handleDeleteRow) => [
    {
      field: "prof_image",
      headerName: "Profile Image",
      width: getColumnWidth("column"),
      renderCell: (params) => {
        return (
          <WholesalerImageCell
            imageUrl={params.value}
            altText={params.row?.product_name}
          />
        );
      },
    },
    // {
    //   field: "prof_image",
    //   headerName: "Profile Image",
    //   width: getColumnWidth("column"),
    //   renderCell: (params) => {
    //     const defaultImage = "https://via.placeholder.com/150";
    //     const imageUrl = params.value || defaultImage;
    //     return (
    //       <div style={styles.listImage}>
    //         <img
    //           src={imageUrl}
    //           alt="Profile Image"
    //           style={styles.listSingleImage}
    //           onError={(e) => {
    //             e.target.src = defaultImage;
    //           }}
    //         />
    //       </div>
    //     );
    //   },
    // },
    {
      field: "reg_no",
      headerName: "Register No",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Not Provided",
    },
    {
      field: "first_name",
      headerName: "First Name",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "First Name Not Provided",
    },
    {
      field: "last_name",
      headerName: "Last Name",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Last Name Not Provided",
    },
    {
      field: "email",
      headerName: "Email",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Email Not Provided",
    },
    {
      field: "phone",
      headerName: "Phone No",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Phone Number Not Provided",
    },
    {
      field: "dob",
      headerName: "Date Of Birth",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Date of Birth Not Provided",
    },
    {
      field: "gender_type",
      headerName: "Gender Type",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Gender Not Provided",
    },
    {
      field: "status",
      headerName: "Status",
      width: getColumnWidth("column"),
      renderCell: (params) => {
        return params.value === 1 ? (
          <ActiveValue>Active</ActiveValue>
        ) : (
          <InactiveValue>Inactive</InactiveValue>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: getColumnWidth("action"),
      renderCell: (params) => (
        <ActionMenu user={params.row} onDelete={handleDeleteRow} />
      ),
    },
  ];

  // useEffect(() => {
  //   const fetchData = async () => {
  //     await dispatch(customerViewAllRequest(currentPage));
  //   };
  //   fetchData();
  // }, [dispatch, currentPage]);

  useEffect(() => {
    const page = currentPage || 1;
    const search = (searchTerm || "").trim();

    const timer = setTimeout(async () => {
      await dispatch(
        customerViewAllRequest({ pageNo: page, search_key: search })
      );
    }, 500);

    return () => clearTimeout(timer);
  }, [currentPage, searchTerm, dispatch]);

  useEffect(() => {
    if (customerViewAllState?.success) {
      setRows(customerList);
    } else {
      setRows(emptyList);
    }
  }, [customerViewAllState, customerList]);

  useEffect(() => {
    if (customerDeleteState?.success) {
      dispatch(customerResetState());
      dispatch(
        customerViewAllRequest({
          pageNo: currentPage || 1,
          search_key: searchTerm?.trim() || "",
          pagination_required: true,
        })
      );
    }
  }, [customerDeleteState?.success]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleDeleteRow = (id) => {
    setUserToDelete(id);
    setOpenDialog(true);
  };

  const confirmDelete = () => {
    dispatch(customerDeleteRequest(userToDelete));
    setUserToDelete(null);
    setOpenDialog(false);
  };

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const handleFilterCondition = (condition) => {
    const sortedRows = [...rows];
    switch (condition) {
      case "Sort by Name Asc":
        sortedRows.sort((a, b) => a?.first_name?.localeCompare(b?.first_name));
        break;
      case "Sort by Name Desc":
        sortedRows.sort((a, b) => b?.first_name?.localeCompare(a?.first_name));
        break;
      case "Sort by Last Order Asc":
        sortedRows.sort((a, b) => a?.LastOrder?.localeCompare(b?.LastOrder));
        break;
      case "Sort by Last Order Desc":
        sortedRows.sort((a, b) => b?.LastOrder?.localeCompare(a?.LastOrder));
        break;
      default:
        console.log(`Unknown filter condition: ${condition}`);
        break;
    }
    setRows(sortedRows);
    handleFilterClose();
  };

  return (
    <>
      <Grid container spacing={2} pl={6} pr={6}>
        <Grid item xs={12} sm={7} md={8} lg={9} xl={9}>
          <Box className="headingTable">
            <h1>Customer Management</h1>
            <p>Here is the complete list of Customers data</p>
          </Box>
        </Grid>
        <Grid item xs={12} sm={5} md={4} lg={3} xl={3}>
          <Box style={filterStyles.style}>
            <Button
              variant="contained"
              startIcon={<FilterIcon color="blue" />}
              endIcon={<ExpandMoreIcon />}
              onClick={handleFilterClick}
              sx={filterStyles.filterColor}
            >
              Filter
            </Button>
          </Box>
        </Grid>
      </Grid>
      <StyledContainer>
        <Menu
          anchorEl={filterAnchorEl}
          open={Boolean(filterAnchorEl)}
          onClose={handleFilterClose}
        >
          <MenuItem onClick={() => handleFilterCondition("Sort by Name Asc")}>
            Customer Name A-Z
          </MenuItem>
          <MenuItem onClick={() => handleFilterCondition("Sort by Name Desc")}>
            Customer Name Z-A
          </MenuItem>
          {/* <MenuItem
            onClick={() => handleFilterCondition("Sort by Last Order Asc")}
          >
            Last Order Lower to Higher
          </MenuItem>
          <MenuItem
            onClick={() => handleFilterCondition("Sort by Last Order Desc")}
          >
            Last Order Higher to Lower
          </MenuItem> */}
        </Menu>
        {customerViewAllState?.inProgress && (
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            bgcolor="rgba(255, 255, 255, 0.5)"
            zIndex={1000}
          >
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
              <CircleLoader
                loading={customerViewAllState?.inProgress}
                size={50}
                color="#0458d3"
              />
            </Box>
          </Box>
        )}

        {customerDeleteState?.inProgress && (
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            bgcolor="rgba(255, 255, 255, 0.5)"
            zIndex={1001}
          >
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
              <CircleLoader
                loading={customerDeleteState?.inProgress}
                size={50}
                color="#d32f2f"
              />
            </Box>
          </Box>
        )}

        <Paper sx={{ position: "relative" }}>
          {/*search*/}
          <Box display="flex" justifyContent="flex-end" mb={2}>
            <input
              type="text"
              placeholder="Search by reg no, name or email..."
              value={searchTerm}
              onChange={handleSearchChange}
              style={{
                padding: "8px 12px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "300px",
              }}
            />
          </Box>
          {customerViewAllState?.inProgress && (
            <Box
              position="absolute"
              top={0}
              left={0}
              right={0}
              bottom={0}
              bgcolor="rgba(255, 255, 255, 0.6)"
              zIndex={10}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <CircleLoader loading={true} size={50} color="#0458d3" />
            </Box>
          )}
          <CustomDataGrid
            rows={rows}
            columns={columns(handleDeleteRow)}
            pageSize={customerPageSize}
            pagination={true}
            onSelectionModelChange={(newSelection) => {
              setSelection(newSelection);
            }}
            rowHeight={80}
          />
          {selection.length > 0 && (
            <div>
              <h2>Selected Rows:</h2>
              {selection.map((id) => (
                <div key={id}>
                  {rows.find((row) => row.id === id).CustomerName}
                </div>
              ))}
            </div>
          )}
        </Paper>
        <Box mt={2}>
          <Grid>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalRecords={totalRecords}
              pageSize={customerPageSize}
            />
          </Grid>
        </Box>
        <DeleteDialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          onConfirm={confirmDelete}
        />
      </StyledContainer>
    </>
  );
};

export default GeneralCustomers;
